import React from 'react';

// Components
import OnedriveItemDetails from './SurfaceItemDetails/OnedriveItemDetails';
import GoogleItemDetails from './SurfaceItemDetails/GoogleItemDetails';
import SalesforceItemDetails from './SurfaceItemDetails/SalesforceItemDetails';
import JiraItemDetails from './SurfaceItemDetails/JiraItemDetails';
import AsanaItemDetails from './SurfaceItemDetails/AsanaItemDetails';

// Styles
import './SurfaceItemDetails.scss';

// Types
import { Type } from 'Shared/types/Capture.types';

type Props = {
  surfaceItem;
};

const SurfaceItemDetails = ({ surfaceItem }: Props) => {
  const baseClassName = 'SurfaceItemDetails__content';

  const getDetails = () => {
    const { type } = surfaceItem;
    if (type === Type.GOOGLE_DRIVE) return <GoogleItemDetails surfaceItem={surfaceItem} />;
    if (type === Type.SALESFORCE) return <SalesforceItemDetails surfaceItem={surfaceItem} />;
    if (type === Type.ONEDRIVE) return <OnedriveItemDetails surfaceItem={surfaceItem} />;
    // if (type === Type.HUBSPOT) return <HubspotItemDetails surfaceItem={surfaceItem} />;
    // if (type === Type.FIGMA) return <FigmaItemDetails surfaceItem={surfaceItem} />;
    // if (type === Type.GITHUB) return <GithubItemDetails surfaceItem={surfaceItem} />;
    if (type === Type.JIRA) return <JiraItemDetails surfaceItem={surfaceItem} />;
    if (type === Type.ASANA) return <AsanaItemDetails surfaceItem={surfaceItem} />;
    else return;
  };
  const details = getDetails();
  return <div className={`${baseClassName}`}>{details}</div>;
};

export default SurfaceItemDetails;
